







import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import fipiLogo from "../assets/images/fipi-logo-white.png";
import IEW_log_header from "../assets/images/IEW_logo - Copy.png";
import Sample from "../assets/images/Digital Library_Cover Image.jpeg";
import { useNavigate } from "react-router-dom";
import CIcon from "@coreui/icons-react";
import { cilAccountLogout } from "@coreui/icons";
import LoginModal from "./LoginModal";
import { Button } from "@mui/material";



import {
  FaSearch,
  FaTwitter,
  FaFacebookF,
  FaLinkedinIn,
  FaEnvelope,
  FaBars,
  FaTimes,
  FaHome
} from "react-icons/fa";

import { TfiYoutube } from "react-icons/tfi";
import "../style/HeaderTabComponent.css";
import { useAuth } from "../context/AuthContext";


const HeaderTabComponent = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [LoginOpen, setLoginOpen] = useState(false);
  const [openDropdowns, setOpenDropdowns] = useState({});
  const navigate = useNavigate();



  const { authUser, login, logout } = useAuth();



  const handleLogout = () => {
    logout();
    navigate("/dashboard");
  };



  const isAdminDashboard = location.pathname.startsWith(
    "/fipidigilibrary/Admin"
  );

  const isHomePage = location.pathname === "/";
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setOpenDropdowns({});
  };


  const toggleDropdown = (dropdownName) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [dropdownName]: !prev[dropdownName],
    }));
  };

  return (
    <div className="header-tab-wrapper">
      <div className="header-contact-bar">
        <div className="header-contact-left">
          <FaEnvelope className="icon" />
          <span>dg.sectt@fipi.org.in</span>
        </div>



        <div className="header-contact-right">
          <FaSearch className="icon" />
          <FaTwitter className="icon"
            onClick={() =>
              window.open("https://x.com/fipiind", "_blank")
            } />
          <FaFacebookF className="icon"
            onClick={() =>
              window.open("https://www.facebook.com/fipiind/", "_blank")
            } />
          <FaLinkedinIn className="icon"
            onClick={() =>
              window.open("https://in.linkedin.com/company/federation-of-indian-petroleum-industry", "_blank")
            } />
          <TfiYoutube className="icon"
            onClick={() =>
              window.open("https://www.youtube.com/channel/UCbmocFLn4uZJCsQQNU_FfJQ", "_blank")
            } />
          <div className="header-contact-last"></div>
          {!isHomePage && (
            authUser ? (
              <div className="header-user">
                <span className="user-email">
                  {authUser.first_name} {authUser.last_name}
                  <small> {authUser.role}</small>
                </span>

                <CIcon
                  icon={cilAccountLogout}
                  className="logout-icon"
                  onClick={handleLogout}
                />
              </div>
            ) :("")
          )}
        </div>

      </div>

      <div className="header-tab-top admin-no-bg">
        <div className="logo-section">
          <img src={fipiLogo} alt="FIPI Logo" className="logo-img"
            onClick={() =>
              window.location.href = "https://fipi.org.in/"
            } />

        </div>

        {/* Mobile Menu Toggle Button */}
        <button className="mobile-menu-toggle" onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <nav className={`main-nav ${isMenuOpen ? "active" : ""}`}>
          <FaHome color="#fff" onClick={() => window.location.href = "https://fipi.org.in/"} />
          <div className="nav-item dropdown">
            <a
              href="#"
              className="dropdown-toggle"
              onClick={(e) => {
                e.preventDefault();
                toggleDropdown("aboutUs");
              }}
            >
              ABOUT US
            </a>
            <div
              className={`dropdown-menu ${openDropdowns.aboutUs ? "show" : ""
                }`}
            >
              <a href="https://fipi.org.in/history.php">History</a>
              <a href="https://fipi.org.in/we-represent.php">We Represent</a>
              <a href="https://fipi.org.in/vision.php">Vision</a>
              <div className="sub-dropdown">
                <a
                  href="#"
                  className="dropdown-toggle"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDropdown("governingCouncil");
                  }}
                >
                  Governing Council
                </a>
                <div
                  className={`dropdown-submenu ${openDropdowns.governingCouncil ? "show" : ""
                    }`}
                >
                  <a href="https://fipi.org.in/governing-council-members.php">
                    Members
                  </a>
                  <a href="https://fipi.org.in/governing-council-meetings.php">
                    Meetings
                  </a>
                </div>
              </div>
              <a href="https://fipi.org.in/leadership-team.php">
                Leadership Team
              </a>



              <div className="sub-dropdown">
                <a
                  href="#"
                  className="dropdown-toggle"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDropdown("annualReport");
                  }}
                >
                  Annual Report
                </a>
                <div
                  className={`dropdown-submenu ${openDropdowns.annualReport ? "show" : ""
                    }`}
                >
                  <a href="https://fipi.org.in/assets/pdf/Annual_Report2024-25.pdf">
                    Annual Report 2024-2025
                  </a>
                  <a href="https://fipi.org.in/assets/pdf/Annual_Report2023-24.pdf">
                    Annual Report 2023-2024
                  </a>
                  <a href="https://fipi.org.in/assets/pdf/Annual_Report2022-23.pdf">
                    Annual Report 2022-2023
                  </a>
                  <a href="https://fipi.org.in/assets/pdf/Annual_Report2021-22.pdf">
                    Annual Report 2021-2022
                  </a>
                  <a href="https://fipi.org.in/assets/pdf/Annual_Report2020-21.pdf">
                    Annual Report 2020-2021
                  </a>
                  <a href="https://fipi.org.in/assets/pdf/Annual_Report2019-20.pdf">
                    Annual Report 2019-2020
                  </a>
                  <a href="https://fipi.org.in/assets/pdf/Annual_Report2018-19.pdf">
                    Annual Report 2018-2019
                  </a>
                  <a href="https://fipi.org.in/assets/pdf/Annual_Report2017-18.pdf">
                    Annual Report 2017-2018
                  </a>
                  <a href="https://fipi.org.in/assets/pdf/Annual_Report2016-17.pdf">
                    Annual Report 2016-2017
                  </a>

                </div>
              </div>
              <a href="https://fipi.org.in/contact-us.php">Contact Us</a>

            </div>
          </div>


          <div className="nav-item dropdown">
            <a
              href="#"
              className="dropdown-toggle"
              onClick={(e) => {
                e.preventDefault();
                toggleDropdown("membership");
              }}
            >
              MEMBERSHIP
            </a>
            <div
              className={`dropdown-menu ${openDropdowns.membership ? "show" : ""
                }`}
            >
              <a href="https://www.fipi.org.in/members.php">Members</a>
              <a href="https://fipi.org.in/who-can-become.php">
                Who can become?
              </a>
              <a href="https://fipi.org.in/Benefits.php">Benefits</a>
              <a href="https://fipi.org.in/member-form.php">Membership Form</a>
            </div>
          </div>

          {/* Media */}
          <div className="nav-item dropdown">
            <a
              href="#"
              className="dropdown-toggle"
              onClick={(e) => {
                e.preventDefault();
                toggleDropdown("media");
              }}
            >
              MEDIA
            </a>
            <div
              className={`dropdown-menu ${openDropdowns.media ? "show" : ""}`}
            >
              <a href="https://fipi.org.in/in-news1.php">FIPI Speaks</a>
              <div className="sub-dropdown">
                <a
                  href="#"
                  className="dropdown-toggle"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDropdown("publication");
                  }}
                >
                  Publications
                </a>
                <div
                  className={`dropdown-submenu ${openDropdowns.publication ? "show" : ""
                    }`}
                >
                  <a href="https://fipi.org.in/fipi-journal.php">Journal</a>
                  <a href="https://fipi.org.in/policy-economic.php">
                    Policy & Economic Report
                  </a>
                </div>
              </div>
              <a href="https://fipi.org.in/video-gallery.php">Videos Gallery</a>
            </div>
          </div>

          {/* Awards */}
          <div className="nav-item dropdown">
            <a
              href="#"
              className="dropdown-toggle"
              onClick={(e) => {
                e.preventDefault();
                toggleDropdown("awards");
              }}
            >
              AWARDS
            </a>
            <div
              className={`dropdown-menu ${openDropdowns.awards ? "show" : ""}`}
            >
              {/* <a href="https://www.fipi.org.in/awards-page2023.php">
                Awards 2025
              </a> */}
              <a href="https://www.award.fipi.org.in/fipiawards">
                Awards 2024
              </a>
              <div className="sub-dropdown">
                <a
                  href="#"
                  className="dropdown-toggle"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDropdown("previousAwards");
                  }}
                >
                  Previous Awards
                </a>
                <div
                  className={`dropdown-submenu ${openDropdowns.previousAwards ? "show" : ""
                    }`}
                >
                  <a href="https://fipi.org.in/awards-page2023.php">
                    Awards 2023
                  </a>
                  <a href="https://fipi.org.in/awards-page2022.php">
                    Awards 2022
                  </a>
                  <a href="https://fipi.org.in/awards-page2021.php">
                    Awards 2021
                  </a>
                  <a href="https://fipi.org.in/awards-2020.php">Awards 2020</a>
                  <a href="https://fipi.org.in/awards-2019.php">Awards 2019</a>
                  <a href="https://fipi.org.in/awards-2017.php">Awards 2017</a>
                  <a href="https://fipi.org.in/awards-2016.php">Awards 2016</a>
                  <a href="https://fipi.org.in/awards-2015.php">Awards 2015</a>
                  <a href="https://fipi.org.in/awards-2014.php">Awards 2014</a>
                  <a href="https://fipi.org.in/awards-2013.php">Awards 2013</a>
                  <a href="https://fipi.org.in/awards-2012.php">Awards 2012</a>
                  <a href="https://fipi.org.in/awards-2011.php">Awards 2011</a>
                  <a href="https://fipi.org.in/awards-2009-2010.php">
                    Awards 2009 & 2010
                  </a>
                  <a href="https://fipi.org.in/awards-2008.php">Awards 2008</a>
                  <a href="https://fipi.org.in/awards-2007.php">Awards 2007</a>
                </div>
              </div>
            </div>
          </div>

          {/* Recommendations */}
<div className="nav-item dropdown">
  <a
    href="#"
    className="dropdown-toggle"
    onClick={(e) => {
      e.preventDefault();
      toggleDropdown("recommendations");
    }}
  >
    RECOMMENDATIONS
  </a>

  <div
    className={`dropdown-menu ${
      openDropdowns.recommendations ? "show" : ""
    }`}
  >
    {/* Recommendations Main */}
    <div className="sub-dropdown">
      <a
        href="#"
        className="dropdown-toggle"
        onClick={(e) => e.preventDefault()}
      >
        Recommendations
      </a>

      <div className="dropdown-submenu">

        {/* Finance */}
        <div className="sub-dropdown finance-dropdown">
          <a
            href="#"
            className="dropdown-toggle"
            onClick={(e) => e.preventDefault()}
          >
            Finance and Taxation
          </a>

          <div className="finance-submenu">
            <a href="https://fipi.org.in/recomm-financegst.php">
              GST
            </a>
          </div>
        </div>

        <a href="https://www.fipi.org.in/recomm-upstream.php">
          Upstream
        </a>

        <a href="https://www.fipi.org.in/recomm-downstream.php">
          Downstream
        </a>

        <a href="https://fipi.org.in/recomm-naturalgas.php">
          Natural Gas
        </a>

      </div>
    </div>

    {/* Reports */}
    <div className="sub-dropdown">
      <a
        href="#"
        className="dropdown-toggle"
        onClick={(e) => e.preventDefault()}
      >
        Reports
      </a>

      <div className="dropdown-submenu">
        <a href="https://fipi.org.in/upstream.php">Upstream</a>

        <a href="https://fipi.org.in/downstream-report.php">
          Downstream
        </a>

        <a href="https://fipi.org.in/downstream-report.php">
          Natural Gas
        </a>

        <a href="https://fipi.org.in/downstream-report.php">
          Economic Policy
        </a>

        <a href="https://fipi.org.in/downstream-report.php">
          Finance and Taxation
        </a>

        <a href="https://fipi.org.in/sustanability-report.php">
          Sustainability & Environment
        </a>

        <a href="https://fipi.org.in/pre-budget-memorandam.php">
          Pre-Budget Memorandom
        </a>
      </div>
    </div>
  </div>
</div>

      {/* Committees */}
      <div className="nav-item dropdown">
        <a
          href="#"
          className="dropdown-toggle"
          onClick={(e) => {
            e.preventDefault();
            toggleDropdown("committees");
          }}
        >
          COMMITTEES
        </a>
        <div
          className={`dropdown-menu ${openDropdowns.committees ? "show" : ""

            }`}
        >

          <a href="https://fipi.org.in/budget-and-investment.php">
            Budget and Investment
          </a>
          <a href="https://fipi.org.in/tariff-duties-taxes.php">
            Tariff, Duties & Taxes
          </a>
          <a href="https://fipi.org.in/lpg-marketing.php">
            LPG Marketing
          </a>
          <a href="https://fipi.org.in/safety-health-environment.php">
            Safety, Health & Environment
          </a>
          <a href="https://fipi.org.in/natural-gas-cng-lng.php">
            Natural Gas / CNG / LNG
          </a>
          <a href="https://fipi.org.in/alternative-sources-of-energy.php">
            Alternative Sources of Energy
          </a>
          <a href="https://fipi.org.in/refiner-s-forum.php">
            Refiner's Forum
          </a>
          <a href="https://fipi.org.in/upstream-operations.php">
            Upstream Operations
          </a>
          <a href="https://fipi.org.in/downstream-marketing.php">
            Downstream Marketing
          </a>
          <a href="https://fipi.org.in/pipeliner-s-forum.php">
            Pipeliner's Forum
          </a>
          <a href="https://fipi.org.in/it-cyber-security.php">
            IT & Cyber Security
          </a>
          <a href="https://fipi.org.in/cbm-shale-gas-gas-hydrates.php">
            CBM/ Shale Oil/ Gas Hydrates
          </a>
          <a href="https://fipi.org.in/audit-committee.php">
            Audit Committee
          </a>
          <a href="https://fipi.org.in/petrochemicals-committee.php">
            Petrochemicals Committee
          </a>
          <a href="https://fipi.org.in/cgd.php">
            City Gas Distribution (CGD)
          </a>
        </div>


      </div>

      {/* Events */}
      <div className="nav-item dropdown">
        <a
          href="#"
          className="dropdown-toggle"
          onClick={(e) => {
            e.preventDefault();
            toggleDropdown("events");
          }}
        >
          EVENTS
        </a>
        <div
          className={`dropdown-menu ${openDropdowns.events ? "show" : ""}`}
        >
          <a href="https://fipi.org.in/events.php">Past Events</a>
          <a href="https://fipi.org.in/upcoming-events.php">
            Upcoming Events
          </a>
        </div>
      </div>



      {/* Digital Library */}
      <div className="nav-item">
        <a
          href="#"

        // onClick={(e) => {
        //   e.preventDefault();
        //   toggleDropdown("digitalLibrary");
        // }}
        >
          DIGITAL LIBRARY
        </a>
        {/* <div
              className={`dropdown-menu ${openDropdowns.digitalLibrary ? "show" : ""
                }`}
            >
              <a href="https://www.indiaenergyweek.com/event/2026/_home">
                India Energy Week
              </a>
              <a href="https://www.fipi.org.in/upcoming-events.php">Upcoming Events</a>
              <a href="https://www.fipi.org.in/events.php">Past Events</a>
            </div> */}
      </div>

      {/* <div className="nav-item">
        <a href="https://cgdhelpdesk.in" target="_blank" rel="noreferrer">
          CGD HELPDESK
        </a>
      </div> */}


      {/* IEW Logo */}
      <div className="logo-section nav-logo">
        <a href="https://www.indiaenergyweek.com/event/2026/_home">
          <img
            src={IEW_log_header}
            alt="IEW Logo"
            className="logo-img-iew"
            onError={(e) => {
              e.target.src = "https://via.placeholder.com/150";
            }}
          />
        </a>
      </div>
    </nav>
      </div >





  {!isAdminDashboard && (
    <div className="header-tab-background">
      <img src={Sample} alt="Homepage Banner" className="banner-img" />
    </div>
  )}


{
  LoginOpen && (
    <LoginModal
      type="user"
      onClose={() => setLoginOpen(false)}
      onLoginSuccess={(user, access, refresh) => {
        login(user, access, refresh);
        setLoginOpen(false);
        navigate("/library");
      }}
    />

  )
}

    </div >
  );
};

export default HeaderTabComponent;